import axios from 'axios'
import router from '../router'
import cookie from './cookie'
import { Message } from 'element-ui'
import getUrl from '../../static/config.json'

// Token 存储 key 定义
const token = {
  token_key: 'access_token_ul_wf',
  token_role_name: 'role_name_ul_wf',
  token_usrname: 'usr_name_ul_wf',
  refresh_key: 'refresh_key_ul_wf'
};

// 后台返回码定义
const backCode = {
  SUCCESS: 0,
  TOKEN_NOT_EXIST: 1281,
  TOKEN_CHECK_FAILED: 1282,
  TOKEN_TIMEOUT: 1283
};

// Token刷新状态管理
const tokenRefreshState = {
  isRefreshing: false,  // 是否正在刷新token
  refreshPromise: null, // 刷新token的Promise
  waitingRequests: []   // 等待token刷新完成的请求队列
};

/**
 * 提示函数
 * @param {string} msg - 提示消息
 * @param {string} type - 类型：success/warning/error/info
 * @param {number} time - 显示时长（毫秒）
 */
function tip(msg, type = 'error', time = 2000) {
  Message({
    message: msg,
    type,
    duration: time,
    showClose: true
  });
}

/**
 * 跳转到登录页
 * @param {string} redirect - 重定向路径
 */
function redirectToLogin(redirect) {
  if (redirect === '/login') {
    router.replace({ path: '/login' });
  } else {
    router.replace({
      path: '/login',
      query: { redirect }
    });
  }
}

/**
 * 解析后台返回码
 * @param {object} data - 响应数据
 * @param {function} callBack - 回调函数
 * @param {*} param - 回调参数
 */
function analysisReturnCode(data, callBack, param = null) {
  const { code, message, msg } = data;
  
  switch (code) {
    case 202:
    case 203:
    case 403:
    case backCode.TOKEN_CHECK_FAILED:
      tip('登录信息已失效，请重新登录');
      redirectToLogin(router.currentRoute.fullPath);
      break;
      
    case backCode.TOKEN_NOT_EXIST:
      tip('token不存在，请重新登录');
      redirectToLogin(router.currentRoute.fullPath);
      break;
      
    case 205:
    case 'ERR_CHECK_TOKEN':
      tip('当前账号被顶替，请重新登录');
      redirectToLogin(router.currentRoute.fullPath);
      break;
      
    case 204:
    case 'ERR_TIMEOUT_TOKEN':
      // 不再作为统一的 token 超时处理，仅提示错误
      tip(message || msg || '登录信息异常，请重新登录');
      redirectToLogin(router.currentRoute.fullPath);
      break;

    case backCode.TOKEN_TIMEOUT:
      // 仅当 code === 1283 时认为 token 超时并尝试刷新
      refresh(callBack, param);
      break;
      
    default:
      tip(message || msg);
  }
}


/**
 * 刷新 Token
 * @param {function} callBack - 刷新成功后的回调
 * @param {*} param - 回调参数
 */
function refresh(callBack, param) {
  // 如果正在刷新，将请求加入等待队列
  if (tokenRefreshState.isRefreshing) {
    tokenRefreshState.waitingRequests.push({ callBack, param });
    return;
  }
  
  tokenRefreshState.isRefreshing = true;
  
  const refreshToken = cookie.getCookie(token.refresh_key);
  cookie.setCookie(token.token_key, refreshToken);
  
  axios.post(`${getUrl.API_ROOT}/Usr/RefreshToken`, {}, {
    headers: { 'Authorization': cookie.getCookie(token.token_key) }
  })
  .then(res => {
    if (res.data.code === backCode.SUCCESS) {
      // 刷新成功，更新 token
      const newToken = res.data.data.authorization || res.data.data.strAuthorization;
      cookie.setCookie(token.token_key, newToken);
      
      // 执行等待队列中的所有回调
      tokenRefreshState.waitingRequests.forEach(({ callBack, param }) => {
        if (callBack) {
          callBack(param);
        }
      });
      tokenRefreshState.waitingRequests = [];
      
      // 执行当前回调
      if (callBack) {
        callBack(param);
      }
    } else {
      handleRefreshFailure();
    }
  })
  .catch(error => {
    console.error('Token refresh error:', error);
    handleRefreshFailure();
  })
  .finally(() => {
    tokenRefreshState.isRefreshing = false;
    tokenRefreshState.refreshPromise = null;
    tokenRefreshState.waitingRequests = [];
  });
}

/**
 * 处理 Token 刷新失败
 */
function handleRefreshFailure() {
  tip('登录信息已失效，请重新登录');
  redirectToLogin(router.currentRoute.fullPath);
}

/**
 * 文件流下载
 * @param {string} url - 文件链接
 * @param {string} fileName - 文件名
 * @param {string} type - 文件类型
 */
function fileLinkToStreamDownload(url, fileName, type) {
  if (!url) {
    throw new Error('文件链接不能为空');
  }
  
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.setRequestHeader('Content-Type', `application/${type}`);
  xhr.responseType = 'blob';
  
  xhr.onload = function() {
    if (this.status === 200) {
      downloadExportFile(this.response, fileName, type);
    }
  };
  
  xhr.send();
}

/**
 * 下载文件
 * @param {Blob|string} blob - 文件 Blob 或 URL
 * @param {string} fileName - 文件名
 * @param {string} fileType - 文件类型
 */
function downloadExportFile(blob, fileName, fileType) {
  const link = document.createElement('a');
  
  if (typeof blob === 'string') {
    link.href = blob;
    link.target = '_blank';
  } else {
    link.href = URL.createObjectURL(blob);
  }
  
  link.download = `${fileName}.${fileType}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  if (typeof blob !== 'string') {
    URL.revokeObjectURL(link.href);
  }
}

/**
 * 下载 PDF 文件
 * @param {string} pdfUrl - PDF 文件链接
 * @param {string} name - 文件名（不包含扩展名）
 */
function downLoadPDF(pdfUrl, name) {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', pdfUrl, true);
  xhr.responseType = 'blob';
  
  xhr.onload = () => {
    if (xhr.status === 200) {
      const blob = new Blob([xhr.response], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      link.download = `${name}.pdf`;
      link.click();
      
      URL.revokeObjectURL(url);
    }
  };
  
  xhr.send();
}

/**
 * 获取枚举常量
 * @returns {object|null} 枚举常量对象
 */
function getConst() {
  const constData = localStorage.getItem('UL_WF_Const');
  return constData ? JSON.parse(constData) : null;
}

/**
 * 根据枚举类型和值获取枚举项
 * @param {string} type - 枚举类型
 * @param {number} value - 枚举值
 * @returns {object|null} 枚举项对象
 */
function getConstItem(type, value) {
  const constData = getConst();
  if (!constData || !constData[type]) {
    return null;
  }

  let list = constData[type];

  // 兼容类型：
  // 1. 直接数组，例如: orderState: [ {...} ]
  // 2. 对象中包含 heart 数组，例如: rptLevel: { heart: [ {...} ] }
  if (!Array.isArray(list) && list && Array.isArray(list.heart)) {
    list = list.heart;
  }

  if (!Array.isArray(list)) {
    return null;
  }

  return list.find(item => item.value == value) || null;
}


export default {
  tip,
  analysisReturnCode,
  token,
  refresh,
  fileLinkToStreamDownload,
  downLoadPDF,
  getConst,
  getConstItem,
  backCode,
  tokenRefreshState,
  ETC_ROOT: getUrl.ETC_ROOT,
  API_ROOT: getUrl.API_ROOT
}



// WEBPACK FOOTER //
// ./src/service/public.js